(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slider-three"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var fadeContainers = document.querySelectorAll('.slide2-right-fade');
  fadeContainers.forEach(function(container) {
    var images = container.querySelectorAll('.fade-image');
    if (images.length < 2) return;
    var current = 0;
    images[current].classList.add('active');
    setInterval(function() {
      images[current].classList.remove('active');
      current = (current + 1) % images.length;
      images[current].classList.add('active');
    }, 3000); // change every 3 seconds
  });
});

  } catch(e) { console.error(e); }
})();
})();
